<template>
  <div class="house-for-rent">
    <div class="column">
      <b-field
        :label="`${$t('if_macau_id_holder')}`"
        :message="$t(validation.firstError('idValue'))"
      >
        <b-select :placeholder="$t('please_select')" v-model="idValue">
          <option
            v-for="option in idQuestion"
            :value="option.id"
            :key="option.id"
          >
            {{ $t(option.value) }}
          </option>
        </b-select>
      </b-field>
    </div>

    <!-- <div class="column">
      <b-field
        :label="`${$t('real_estate_type')}`"
        :message="$t(validation.firstError('realEstateType'))"
      >
        <b-select :placeholder="$t('please_select')" v-model="realEstateType">
          <option
            v-for="type in realEstateTypes"
            :value="type.id"
            :key="type.id"
          >
            {{ $t(type.value) }}
          </option>
        </b-select>
      </b-field>
    </div> -->

    <div class="column">
      <b-field
        :label="`${$t('expect_rent_value')}`"
        :message="$t(validation.firstError('expectRentValue'))"
      >
        <p class="control">
          <b-button>MOP</b-button>
        </p>
        <b-input
          v-model="expectRentValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div v-if="isShowResult" class="column">
      <b-table
        :data="this.tableData"
        :columns="this.columns"
        :hoverable="true"
        :bordered="true"
        :striped="true"
      >
      </b-table>
    </div>

    <div v-if="isShowResult" class="column is-full">
      1) {{ $t("remark_3_1") }}
    </div>

    <div v-if="isShowResult" class="column is-full">
      1) {{ $t("remark_1") }}
    </div>

    <div v-if="isShowResult" class="column is-full">
      2) {{ $t("remark_2") }}
    </div>

    <div class="column">
      <b-button
        @click="calculate"
        class="is-primary"
        style="background-color: #00775e"
      >
        {{ $t("calculate") }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expectRentValue: "",
      idValue: "1",
      idQuestion: [
        {
          id: 1,
          value: "yes"
        },
        {
          id: 2,
          value: "no"
        }
      ],
      realEstateType: "3",
      realEstateTypes: [
        {
          id: 1,
          value: "residential"
        },
        {
          id: 2,
          value: "business"
        },
        {
          id: 3,
          value: "other"
        }
      ],
      tableData: "",
      isShowResult: false
    };
  },

  validators: {
    expectRentValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .integer();
    },

    idValue: function(value) {
      return this.$validator()
        .value(value)
        .required();
    },

    realEstateType: function(value) {
      return this.$validator()
        .value(value)
        .required();
    }
  },

  computed: {
    columns() {
      return [
        {
          field: "tax_revenue",
          label: this.$t("tax_revenue"),
          numeric: true
        },
        {
          field: "tax",
          label: this.$t("tax"),
          numeric: true
        },
        {
          field: "except_house_tax",
          label: this.$t("except_house_tax"),
          numeric: true,
          headerClass: "red-font",
          cellClass: "red-font"
        },
        {
          field: "total_tax_amt",
          label: this.$t("total_tax_amt"),
          numeric: true
        }
      ];
    }
  },

  methods: {
    calculate() {
      let results = [
        {
          tax_revenue: this.$options.filters.formatNumberWithoutPoint(
            this.calTaxRevenue()
          ),
          tax: this.$options.filters.formatNumberWithoutPoint(this.calTax()),
          except_house_tax: this.$options.filters.formatNumberWithoutPoint(
            this.calExceptHouseTax()
          ),
          total_tax_amt: this.$options.filters.formatNumberWithoutPoint(
            this.calTotalTax()
          )
        }
      ];

      this.tableData = results;

      this.$validate().then((success) => {
        if (success) {
          this.isShowResult = true;
        }
      });
    },

    calTaxRevenue() {
      return this.expectRentValue * 0.9;
    },

    calTax() {
      return Math.round(this.calTaxRevenue() * 0.06);
    },

    calExceptHouseTax() {
      const calTax = this.calTax();

      if (this.idValue == 1 && this.realEstateType == 1) {
        return calTax;
      }

      if (this.idValue >= 1 && this.realEstateType == 2) {
        if (calTax - 3500 > 0) {
          return Math.round((calTax - 3500) * 0.25) + 3500;
        }
        return 0 + 3500;
      }

      if (this.idValue == 1 && this.realEstateType == 3) {
        return 3500;
      } else {
        return 0;
      }
    },

    calTotalTax() {
      if (
        Math.round(this.calTaxRevenue() * 0.06) - this.calExceptHouseTax() >
        49
      ) {
        return (
          Math.round(this.calTaxRevenue() * 0.06) - this.calExceptHouseTax()
        );
      }
      return 0;
    }
  }
};
</script>

<style>
.red-font {
  color: red !important;
}
</style>
